import Url from 'url-parse';
var WixStatics = /** @class */ (function () {
    function WixStatics() {
    }
    WixStatics.fileUrl = function (fileUrl) {
        return "".concat(WixStatics.WIX_STATIC, "/").concat(fileUrl);
    };
    WixStatics.videoUrl = function (fileUrl) {
        return "".concat(WixStatics.WIX_STATIC_VIDEO_BASE_URL, "/").concat(mediaIdFromUrl(fileUrl));
    };
    WixStatics.imageUrl = function (fileUrl) {
        return "".concat(WixStatics.WIX_STATIC, "/media/").concat(mediaIdFromUrl(fileUrl));
    };
    WixStatics.getWixmpFileNameFromImageURL = function (wixMPImageURL) {
        var path = wixMPImageURL.replace(WixStatics.WIXMP_IMAGE_BASE_URL, '');
        var fileName = path.split('/').pop().split('?')[0];
        return { path: path, fileName: fileName };
    };
    WixStatics.isWixmpImageURL = function (image) {
        if (!image) {
            return false;
        }
        return WixStatics.WIXMP_IMAGE_PATTERN.test(image);
    };
    WixStatics.isWixmpUrl = function (url) {
        return WixStatics.WIXMP_PATTERN.test(url);
    };
    WixStatics.toWixmpImageURL = function (src) {
        var _url = new Url(src);
        if (WixStatics.isWixmpImageURL(src)) {
            return _url;
        }
        if (WixStatics.isWixmpUrl(src)) {
            _url.set('host', "images-".concat(_url.host));
            return _url;
        }
        return null;
    };
    WixStatics.WIXMP_IMAGE_BASE_URL = 'https://images-wixmp-7ef3383b5fd80a9f5a5cc686.wixmp.com';
    WixStatics.WIX_STATIC = 'https://static.wixstatic.com';
    WixStatics.WIX_STATIC_VIDEO_BASE_URL = 'https://video.wixstatic.com/video';
    WixStatics.WIXMP_IMAGE_PATTERN = /images-wixmp-.*.wixmp.com/;
    WixStatics.WIXMP_PATTERN = /wixmp-.*.wixmp.com/;
    return WixStatics;
}());
export { WixStatics };
/**
 *  replaces substring that starts with
 *  - /
 *  - /media
 *  - /video
 *  - /media/video
 * @param  mediaUrl
 */
function mediaIdFromUrl(mediaUrl) {
    return mediaUrl.replace(/(^\/*(media*\/*)?(video*\/*)?)/g, '');
}
//# sourceMappingURL=WixStatics.js.map